function toggleReviews() {
    const grid = document.getElementById('ReviewGrid');
    const btnText = document.getElementById('ToggleText');
    const isExpanded = grid.classList.contains('is-expanded');
    const hiddenReviews = document.querySelectorAll('.custom-default-hidden-reviews');

    if (!isExpanded) {
        grid.classList.add('is-expanded');
        btnText.innerText = "Hide Samples";
        btnText.style.position = 'sticky';
        hiddenReviews.forEach(review => {
            review.style.display = 'block';
        });
    } else {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const yOffset = isMobile ? 60 : 70;
        const y = grid.getBoundingClientRect().top - yOffset + window.scrollY;

        console.log(y, grid.getBoundingClientRect().top, yOffset);

        window.scrollTo({ top: y, behavior: 'smooth' });

        grid.classList.remove('is-expanded');
        btnText.innerText = "View All Samples";
        btnText.style.position = '';
        hiddenReviews.forEach(review => {
            review.style.display = 'none';
        });
    }
}
